export default "__VITE_ASSET__XiveGiwZ__"